import { render, staticRenderFns } from "./Bedankt.vue?vue&type=template&id=12e9af2a&scoped=true"
import script from "./Bedankt.vue?vue&type=script&lang=js"
export * from "./Bedankt.vue?vue&type=script&lang=js"
import style0 from "./Bedankt.vue?vue&type=style&index=0&id=12e9af2a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12e9af2a",
  null
  
)

export default component.exports